export enum PhoneVerificationStatuses {    
    PV_TODO = "PV_TODO",
    PV_VERIFIED = "PV_VERIFIED",
    PV_AWAITING_VERIFICATION = "PV_AWAITING_VERIFICATION",
    PV_PENDING = "PV_PENDING",
    PV_INITIATED = "PV_INITIATED",
    PV_FAILED = "PV_FAILED",
    PV_EXPIRED = "PV_EXPIRED",

    OTP_FAILED = "OTP_FAILED",
    OTP_VERIFIED = "OTP_VERIFIED",
    OTP_EXPIRED = "OTP_EXPIRED",

    OTP_FAILED_BASS = "02301031",
    OTP_EXPIRED_BASS = "02301034",


}
